// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.ClickModal_bodyOverflow__y4qUZ {
  overflow: hidden;
}

.ClickModal_wrap__iOTKX,
.ClickModal_rootBlur__3EsBD {
  --transition-duration: 0.2s;
}

.ClickModal_rootBlur__3EsBD {
  filter: grayscale(1) opacity(0.25);
  transition: all var(--transition-duration);
}

.ClickModal_wrap__iOTKX {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: var(--blackAlpha);
  z-index: var(--modalIndex);
  animation-duration: var(--transition-duration);
}
.ClickModal_wrap__iOTKX .ClickModal_modal__GEuML {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--gray);
  border-radius: calc(2 * var(--border-radius));
  background: var(--white);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
  animation-duration: var(--transition-duration);
  --margin: 80px;
  max-height: calc(100% - var(--margin));
  max-width: calc(100% - var(--margin));
  --padding: 2em;
  padding: var(--padding);
}
@media (max-width: 767.98px) {
  .ClickModal_wrap__iOTKX .ClickModal_modal__GEuML {
    --margin: 40px;
  }
}
.ClickModal_wrap__iOTKX .ClickModal_modal__GEuML .ClickModal_content__eW3-A {
  display: flex;
  flex-shrink: 1;
  height: 100%;
  min-height: 0;
}
.ClickModal_wrap__iOTKX .ClickModal_modal__GEuML .ClickModal_content__eW3-A:not(:last-child) {
  margin-bottom: 1em;
}
.ClickModal_wrap__iOTKX .ClickModal_modal__GEuML .ClickModal_footer__3ZVuS {
  display: flex;
  justify-content: flex-end;
}
.ClickModal_wrap__iOTKX .ClickModal_modal__GEuML .ClickModal_close__F8VW3 {
  position: absolute;
  right: 0;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/components/ClickModal/ClickModal.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACEA;EACE,gBAAA;AAAF;;AAGA;;EAEE,2BAAA;AAAF;;AAGA;EACE,kCAAA;EACA,0CAAA;AAAF;;AAGA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,0BAAA;EACA,8CAAA;AAAF;AAEE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,6CAAA;EACA,wBAAA;EACA,0CAAA;EACA,8CAAA;EACA,cAAA;EACA,sCAAA;EACA,qCAAA;EAEA,cAAA;EACA,uBAAA;AADJ;ADfI;ECEF;IAiBI,cAAA;EAAJ;AACF;AACI;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AACN;AACI;EACE,kBAAA;AACN;AAEI;EACE,aAAA;EACA,yBAAA;AAAN;AAGI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AADN","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n\n.bodyOverflow {\n  overflow: hidden;\n}\n\n.wrap,\n.rootBlur {\n  --transition-duration: 0.2s;\n}\n\n.rootBlur {\n  filter: grayscale(1) opacity(0.25);\n  transition: all var(--transition-duration);\n}\n\n.wrap {\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  background: var(--blackAlpha);\n  z-index: var(--modalIndex);\n  animation-duration: var(--transition-duration);\n\n  .modal {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--gray);\n    border-radius: calc(2 * var(--border-radius));\n    background: var(--white);\n    box-shadow: 1px 1px 5px rgba(black, 0.5);\n    animation-duration: var(--transition-duration);\n    --margin: 80px;\n    max-height: calc(100% - var(--margin));\n    max-width: calc(100% - var(--margin));\n\n    --padding: 2em;\n    padding: var(--padding);\n\n    @include breakpoint-down(sm) {\n      --margin: 40px;\n    }\n    .content {\n      display: flex;\n      flex-shrink: 1;\n      height: 100%;\n      min-height: 0;\n    }\n    .content:not(:last-child) {\n      margin-bottom: 1em;\n    }\n\n    .footer {\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .close {\n      position: absolute;\n      right: 0;\n      top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyOverflow": `ClickModal_bodyOverflow__y4qUZ`,
	"wrap": `ClickModal_wrap__iOTKX`,
	"rootBlur": `ClickModal_rootBlur__3EsBD`,
	"modal": `ClickModal_modal__GEuML`,
	"content": `ClickModal_content__eW3-A`,
	"footer": `ClickModal_footer__3ZVuS`,
	"close": `ClickModal_close__F8VW3`
};
export default ___CSS_LOADER_EXPORT___;
